export default {
  "iso3": "por",
  "iso2": "pt",
  "text": {
    "100200": "Lamentamos, este jogo parece estar restrito na sua área.",
    "CURRENT_LANGUAGE": "Português",
    "CIP8_TITLE": "JOGOS DO 888CASINO",
    "Login": "INICIAR SESSÃO",
    "WITHDRAW": "LEVANTAR",
    "CASHIER": "Caixa",
    "Search": "Pesquisar o seu jogo...",
    "REWARDS": "Recompensas",
    "HOME": "Início",
    "888_COM": "888.com",
    "888_POKER": "poker",
    "888_CASINO": "casino",
    "888_BINGO": "bingo",
    "888_SPORT": "sport",
    "SIGN_UP": "REGISTRAR-SE",
    "DEPOSIT_SIDE_MENU": "Depósito",
    "MY_ACCOUNT": "A Minha Conta",
    "BALANCE": "O Seu Saldo",
    "LOGOUT": "Terminar sessão",
    "GREETING_MORNING": "Bom Dia",
    "GREETING_AFTERNOON": "Boa Tarde",
    "GREETING_EVENING": "Boa Noite",
    "GREETING_NIGHT": "Boa Madrugada",
    "GREETING_DEFAULT": "Olá",
    "MRS_TITLE": "Sra.",
    "MR_TITLE": "Sr.",
    "SLOTS": "Slots",
    "LOBBY": "Lobby",
    "SLOTS_JACKPOTS": "Slots e Jackpots",
    "CARD_TABLE_GAMES": "Jogos de Cartas e Mesa",
    "ALL_SDM_GAMES": "Todos os Jogos SDM",
    "CASINO_GAMES": "Jogos de Cassino",
    "LIVE_CASINO": "Cassino AO VIVO",
    "PROMOTIONS": "Promoções",
    "888SPORT": "888sport",
    "VIP_CLUB": "VIP Club",
    "PWA_INSTALL": "Instalar Aplicativo",
    "PWA_ADD_TO_HOME_SCREEN": "Adicionar à tela inicial",
    "PWA_TAP": "Clique",
    "PWA_QUICK_LAUNCH": "Lançamento rápido da {BRAND}",
    "BLOG": "Blog",
    "TODAY_WINNERS": "Vencedores de Hoje",
    "SUPPORT_ID_MESSAGE": "ID de Suporte",
    "DEPOSIT": "DEPÓSITO",
    "CHOOSE_LANG": "Escolha o seu idioma",
    "CHOOSE_COUNTRY": "Escolha o seu país",
    "SIGN_IN_PLAY": "REGISTRAR-SE E JOGAR",
    "NEW": "Novidade",
    "JACKPOT": "Jackpot",
    "BRAND_EXCLUSIVE_FILTER": "{brandName} Exclusivo",
    "EXCLUSIVE": "888 Exclusivo",
    "SI_EXCLUSIVE": "SI Exclusivo",
    "YGGDRASIL": "Yggdrasil",
    "1-25_LINES": "1-25 linhas",
    "25+_LINES": "25+ linhas",
    "888_EXCLUSIVE_GAMES": "888 Jogos Exclusivos",
    "INFO_TITLE_ARENA_888_EXCLUSIVE_GAMES": "Jogos Exclusivos de 888",
    "INFO_TEXT_ARENA_888_EXCLUSIVE_GAMES": "Nada bate um simples e apaixonante jogo de slots o de roleta. É só escolher o nível de aposta, as linhas de pagamento e ... boa sorte! Que emocionante é esperar o resultado e saber se somos vencedores ou não. Mais ainda, aquele jackpot acumulado pode ser seu finalmente! Vai arriscar? Arrisque nas nossas mais de 100 slots e jogos de roleta e divirta-se com todas as temáticas dos jogos, rondas bónus, jogadas bónus, wilds, etc.",
    "INFO_TITLE_ARENA_SLOTS": "Slots",
    "INFO_TEXT_ARENA_SLOTS": "Escolha entre mais de 100 slots da melhor qualidade e jogue em qualquer lado, online. Desfrute de uma ampla variedade de funcionalidades, tais como Jogos de Bónus, Wilds de Expansão, Rodadas Grátis e Jackpots Fenomenais. Quer aproveitar o tesouro no antigo Egito, procurar o pote de ouro do Duende ou prefere continuar pelo clássico? Seja qual for o seu tema de eleição, estamos certos que vai encontrar o seu jogo preferido!",
    "INFO_TITLE_ARENA_CASINO": "Jogos de Cassino",
    "INFO_TEXT_ARENA_CASINO": "As cartas são baralhadas, a roda gira e o seu lugar espera por si Jogue apenas os melhores jogos de cartas e mesas online. Escolha entre uma variedade de jogos de Roleta, incluindo apostas Europeia, Americana, Apostas Baixas, Altas e Super. Prefere o Blackjack? Jogue várias mãos ao mesmo tempo. De Texas Hold’em a Caribbean, não deixe de encontrar a sua preferência pelo póquer!",
    "INFO_TITLE_ARENA_ROULETTE": "Roleta",
    "INFO_TEXT_ARENA_ROULETTE": "Tente acertar nos seus números da sorte numa das principais mesas de roleta online do 888casino. Escolha entre a nossa ampla variedade de estilos de jogos de roleta, incluindo europeia, americana e francesa. Quer seja um High Roller ou prefira apostas baixas, existe um jogo de roleta para si. Não há nada como a emoção de esperar que a bola caia quando joga roleta!.",
    "INFO_TITLE_ARENA_NEW_GAMES": "Novos Jogos",
    "INFO_TEXT_ARENA_NEW_GAMES": " ",
    "INFO_TITLE_ARENA_BLACKJACK": "Blackjack Online",
    "INFO_TEXT_ARENA_BLACKJACK": "As cartas são baralhadas e seu lugar espera por alguns dos melhores jogos de blackjack online que encontrará! Jogue blackjack no 888casino nos seus próprios termos com Super Apostas, Apostas Adicionais e mais. Uma mão de blackjack não é suficiente para si? Jogue no nosso Blackjack Multimãos para três hipóteses de conseguir 21, ao mesmo tempo!",
    "INFO_TITLE_ARENA_VIDEO_POKER": "Póquer de Vídeo Online",
    "INFO_TEXT_ARENA_VIDEO_POKER": "Se acha que é um verdadeiro profissional de póquer, veio ao casino certo! Opte por aquele indescritível Royal Flush nos nossos vários tipos de jogos de póquer de vídeo  Se gosta de jogos com cinco cartas ou se prefere o sempre popular Texas Hold’em, certamente encontrará o seu novo jogo de póquer de vídeo online favorito no 888casino.",
    "INFO_TITLE_ARENA_SCRATCH_CARDS": "Raspadinha Online",
    "INFO_TEXT_ARENA_SCRATCH_CARDS": "Não há nada como uma vitória rápida num dos emocionantes jogos de raspadinha do 888casino. Ideal para alguma diversão sem estratégia, escolha uma raspadinha online no tema da sua escolha. Revele as suas riquezas irlandesas ou descubra a fortuna do faraó, depende de si. Basta escolher o montante que deseja apostar e ver se é um vencedor de raspadinha!",
    "INFO_TITLE_ARENA_JACKPOTS": "Jackpots",
    "INFO_TEXT_ARENA_JACKPOTS": "Divirta-se à grande com slots dos mais variados temas. Parta em busca de tesouros, encarne o papel de pirata ou enfrente os medos de Elm Street com jogos divertidos e memoráveis. Experimente as emoções das slots com rondas de bónus, jogadas grátis e jackpots massivos dignos de notícia. Siga os jogos com jackpots acumulados e arrisque. Boa sorte!",
    "NETENT_SLOTS": "NETENT SLOTS",
    "BONUS": "Bónus",
    "FREE_SPINS": "Voltas Grátis",
    "CLEAR_ALL": "Limpar Tudo",
    "FILTER": "Filtrar",
    "APPLY": "Aplicar",
    "ROULETTE": "Roleta",
    "ELITE_LOUNGE": "LOUNGE ELITE",
    "BLACKJACK": "Blackjack",
    "BACCARAT": "Baccarat",
    "POKER": "Póquer",
    "KENO": "Keno",
    "HIGH_LIMIT": "Limite Superior",
    "LANGUAGES": "Idiomas",
    "HELP": "Ajuda",
    "LIVE_CHAT": "Chat ao Vivo",
    "DEMO": "Demo",
    "PLAY": "Jogar",
    "NOT_NOW": "Agora não",
    "MAYBE_LATER": "Agora não",
    "NO_THANKS": "Não, obrigado",
    "LETS_PLAY": "Vamos jogar!",
    "GOT_IT": "GOT IT!",
    "LIMITS": "Limites",
    "LIVE": "Ao Vivo",
    "SEE_ALL": "Ver Tudo",
    "WINNING_IN_THE_LAST_30_DAYS": "Ganhar nos últimos 30 dias",
    "TOTAL_JACKPOTS": "Total Jackpots",
    "TOP_GAMES": "PRINCIPAIS JOGOS SLOT",
    "LIVE_CASINO_TABLES": "MESAS AO VIVO SELECIONADAS",
    "TOP_CASINO_GAMES": "PRINCIPAIS JOGOS DE CASsINO",
    "JACKPOTS": "Jackpots",
    "RECENTLY_PLAYED": "Recentemente Pagos",
    "BECAUSE_YOU_PLAYED": "Porque você jogou {gameName}",
    "MINIMUM_BET": "Aposta Mín.",
    "MAXIMUM_BET": "Aposta Máx.",
    "PAYLINES": "Linhas de pagamento",
    "BONUS_GAME": "Jogo com bónus",
    "MAX_PER_SPOT": "Máx. Por Spot",
    "MULTIPLAYER": "Multijogadores",
    "DECKS": "Baralhos",
    "SIDE_BETS": "Apostas Adicionais",
    "ABOUT": "Sobre",
    "GAME_JACKPOT": "Jackpot do Jogo",
    "SLOT_GAMES": "Jogos de Slot",
    "CARD_AND_TABLE_GAMES": "Jogos de Cartas e Mesa",
    "JACKPOT_GAMES": "Jogos com Jackpot",
    "JACKPOT_CENTRAL": "Jackpot Central",
    "OTHER": "Outro",
    "POKER_GAMES": "JOGOS DE PÓQUER",
    "YOUR_SEARCH_DID_NOT_MATCH_ANY_GAMES": "A sua pesquisa não correspondeu a quaisquer jogos",
    "PREMIER_ONLINE_LIVE_CASINO": "Casino ao vivo Premier",
    "All_SLOTS": "Todos os Slots",
    "All_CARD_AND_TABLE_GAMES": "Todos os Jogos de Cartas e Mesa",
    "USEFUL_LINKS": "Links úteis",
    "PRIVACY_POLICY": "Política de Privacidade",
    "USER_AGREEMENT": "Contrato do Utilizador",
    "RESPONSIBLE_GAMBLING": "Jogando com Responsabilidade",
    "SAFE_ZONE": "Centro de Controle",
    "CONTACT": "Contacte-nos",
    "COMP_POINTS": "Pontos de Bónus",
    "HISTORY": "Histórico",
    "GAMING_HISTORY": "Histórico do Jogo",
    "TIPPING_HISTORY": "Histórico de dicas",
    "TIPPING_HISTORY_AMOUNT": "Tip Amount",
    "GAMING_SESSION_HISTORY": "Histórico de Sessões",
    "MY_CHALLENGES": "Os Meus Desafios",
    "SCRATCHCARDS": "Raspadinhas",
    "QUICK_LINKS_TITLE": "LINKS RÁPIDOS",
    "NO_SEARCH_RESULTS": "Sem Resultados de Pesquisa Encontrados...",
    "SEARCH_YOUR_GAME": "Encontre jogos, temas e estúdios",
    "SEARCH_RESULTS_TITLE": "PRINCIPAIS RESULTADOS DE PESQUISA",
    "SUGGESTED_GAMES": "JOGOS SUGERIDOS",
    "SUGGESTED_CATEGORIES": "CATEGORIAS SUGERIDAS",
    "BACK": "Voltar",
    "HIT_THE_JACKPOT": "Atingir o Jackpot",
    "OUR_JACKPOTS": "OS NOSSOS JACKPOTS",
    "MY_CLUB": "O Meu Clube",
    "LOW_ROLLERS": "Low Rollers",
    "CASH_BALANCE": "Saldo do Dinheiro",
    "BONUS_BALANCE": "Saldo do Bónus",
    "YOU_MAY_LIKE": "É POSSÍVEL QUE GOSTE DE",
    "TOP_PICKS_FOR": "ESCOLHAS PRINCIPAIS PARA {USERNAME}",
    "888CLUB": "Clube 888",
    "888POKER": "888poker",
    "BACK_TO_888POKER": "Voltar a888poker",
    "BACK_TO_888SPORT": "Voltar a888sport",
    "VIDEO_POKER_GAMES": "Jogos de Poker por Vídeo",
    "VIDEO_POKER": "Póquer de Vídeo",
    "SEO_IMAGE_CATEGORIES_TITLE": "{categoryName}: A melhor experiência em 888casino",
    "SEO_IMAGE_CATEGORIES_ALT": "Casino online - {categoryName}",
    "SEO_IMAGE_GAME_TITLE": "{gameName} - {categoryName}",
    "NETENT": "NETENT",
    "TOP_NETENT_SLOTS": "PRINCIPAIS SLOTS NETENT",
    "PLAY_50_FREESPINS": "JOGUE 50 VOLTAS GRÁTIS",
    "HOLIDAY_GAMES": "JOGOS DE FERIADOS",
    "ORIGINALS": "888 Originais",
    "RELATED_GAMES": "PORQUE ESCOLHEU {gameName}",
    "HIGH_VOLATILITY": "Volatilidade alta",
    "LOW_VOLATILITY": "Volatilidade baixa",
    "IN_HOUSE_SLOTS": "Caça-níqueis da casa",
    "MORE_GAMES": "Mais jogos",
    "CLASSIC_SLOTS": "SLOTS CLÁSSICAS",
    "ALL_JACKPOTS": "TODOS OS JACKPOTS",
    "POPULAR_GAMES_TITLE": "Jogos populares",
    "POPULAR_INHOUSE_GAMES": "Jogos In-House Populares",
    "POPULAR_NETENT_GAMES": "Jogos Netent Populares",
    "MORE": "Mais",
    "HOMEPAGE-SPOOKY_SPINS": "Spooky Spins",
    "THE_DAILY_JACKPOT": "888 JACKPOT DIÁRIO",
    "HIGH_NOON_JACKPOT": "Jackpot do Meio-Dia",
    "TWILIGHT_JACKPOT": "Twilight Jackpot",
    "POWER8_JACKPOT": "POWER 8 JACKPOT",
    "RED_TIGER_DAILY_JACKPOT": "JACKPOT DIÁRIO DA RED TIGER",
    "RED_TIGER_HOURLY_JACKPOT": "Jackpot por hora da Red Tiger",
    "PROGRESSIVE_JACKPOTS": "JACKPOTS PROGRESSIVOS",
    "INSTANT_GAMES": "Jogos Instantâneos",
    "INSTANT_WIN_GAMES_ARENA": "Jogos Instantâneos",
    "ALL_INSTANT_WIN_GAMES": "TODOS OS JOGOS COM GANHOS INSTANTÂNEOS",
    "INFO_TITLE_ARENA_INSTANT_WIN_GAMES": "Instant Gaming",
    "INFO_TEXT_ARENA_INSTANT_WIN_GAMES": "Os jogos instantâneos são imensamente DIVERTIDOS! Prepare-se para raspar e ganhar com as melhores raspadinhas. Temos tantos jogos para desfrutar como o Volcano Eruption, Panda Mania, e Merlin’s Millions. Está com pouco tempo? Não se preocupe, experimente o Keno e os jogos Bingo, ou ainda títulos emocionantes como o Chicken Extreme, 7-UP, e Epic Gems. É uma festa e está convidado. Os jogos Instant Win são realmente fáceis de jogar. Não precisa de muito – basta jogar e ganhar!",
    "TRENDING_SLOTS": "Slots em alta",
    "EXCLUSIVE_LIVE_TABLES": "MESAS EXCLUSIVAS EM DIRETO",
    "BLACKJACK_AND_ROULETTE_GAMES": "BLACKJACK & JOGOS DE ROLETA",
    "ALL_888_EXCLUSIVE_GAMES": "TODOS 888 JOGOS EXCLUSIVOS",
    "LIVE_ARENA_TABLE_IS_CLOSED_MESSAGE": "A mesa abre às",
    "LIVE_CASINO_TABLE_FULL_PC": "Mesa cheia",
    "LIVE_CASINO_TABLE_FULL_MOBILE": "Cheia",
    "GAME_SHOWS": "Game Shows",
    "TOP_EVO_GAMES": "Melhores jogos",
    "FOR_YOU_GAMES": "PARA SI",
    "VIRTUAL_SPORTS": "Esportes Virtuais",
    "INFO_TITLE_ARENA_VIRTUAL_SPORTS": "Esportes Virtuais",
    "INFO_TEXT_ARENA_VIRTUAL_SPORTS": "Esportes Virtuais traz para você uma grande variedade de jogos de esportes gerados por computador nos quais você pode apostar 24 horas. Então, por que esperar aquele grande jogo hoje à noite quando você pode apostar em nossos jogos virtuais agora mesmo?",
    "MINI_ORBIT_BALANCE": "Saldo:",
    "REAL_MONEY_GAME": "Só é possível jogar este jogo com seu saldo em dinheiro.",
    "NEW_GAMES_LIST_TITLE": "Novos jogos de cassino online",
    "NEW_GAMES": "Novos jogos",
    "TOP_EXCLUSIVE_SLOTS": "TOP Slots exclusivos",
    "TOP_10_IN_YOUR_COUNTRY": "Top 10 no seu país",
    "LETS_PLAY_MONOPOLY": "Vamos jogar Monopoly",
    "TOP_TRENDING_SLOTS": "Slots mais populares",
    "TOP_PAYING_SLOTS": "Slots com maiores ganhos",
    "RECENTLY_ADDED": "Adicionado recentemente",
    "TOP_SLOTS": "Principais slots",
    "CANT_CONNECT_ERROR_TITLE": "Não é possível se conectar",
    "CANT_CONNECT_ERROR_MESSAGE": "Desculpe, há algo errado aqui.",
    "RETRY": "TENTE NOVAMENTE",
    "TRANSACTION_HISTORY": "Histórico do Transações",
    "HOTTEST_NEW_GAMES": "Jogos Novos mais Procurados",
    "BRAND_NEW": "Novíssimos",
    "SINCE_LAST_MONTH": "Desde o Último Mês",
    "SAFE_GAMBLING_TOOLTIP": "Ferramentas e informações mais seguras para jogos de azar",
    "GAME_POPUP_GAME_UNAVAILABLE": "Desculpe, o jogo não está disponível.",
    "GAME_POPUP_MAY_LIKE": "Talvez você também goste de:",
    "PARTY_JACKPOT_WELCOME_POPUP_TITLE": "VIVA! Estás prestes a jogar um jogo {partyJackpotName}!",
    "PARTY_JACKPOT_WELCOME_POPUP_TITLE_ALL_LIVE_CASINO": "LUCKY YOU!",
    "PARTY_JACKPOT_WELCOME_POPUP_SUB_TITLE_ALL_LIVE_CASINO": "All Live Casino games are part of our HOT NEW jackpot!",
    "PARTY_JACKPOT_WELCOME_POPUP_DESCRIPTION": "É possível ganhar o Jackpot com qualquer aposta do saldo em dinheiro.\nTodos os prêmios do Party Jackpot são bônus, creditados instantaneamente em sua conta.",
    "PARTY_JACKPOT_WELCOME_POPUP_DESCRIPTION_REAL": "Qualquer aposta no modo de jogo a dinheiro em um Party Jackpot pode ganhar um prêmio em dinheiro.\nO Party Jackpot pagará diariamente.",
    "PARTY_JACKPOT_WELCOME_POPUP_DESCRIPTION_REAL_HOURLY": "Any real money bet on a Party Jackpot game could win a cash prize!\nThe Party Jackpot will pay hourly between {startHour} to {endHour}",
    "PARTY_JACKPOT_WELCOME_POPUP_DESCRIPTION_REAL_HOURLY_ALL_LIVE_CASINO": "Real money bets on any Live Casino game could win the jackpot! The Live Casino Jackpot must pay every hour, {startHour} - {endHour}, and is fully funded by us.",
    "PARTY_JACKPOT_WELCOME_POPUP_BOTTOM_NOTE": "Bônus: apostar 30x (varia conforme o jogo), válido por 90 dias, ganhos máx. US$ 500, válido nos jogos selecionados",
    "PARTY_JACKPOT_WELCOME_POPUP_BOTTOM_NOTE_REAL": "Só jogadores que já depositaram",
    "PARTY_JACKPOT_WELCOME_POPUP_TERMS_AND_CONDITIONS_APPLY": "Sujeito aos termos e condições",
    "PARTY_JACKPOT_WIN_TOASTER_TITLE": "O {jackpotName} acabou de cair em {winAmount}!",
    "PARTY_JACKPOT_WIN_TOASTER_SUBTITLE": "Não ganhou? Não se preocupe!\n Este jackpot cai a cada hora, {startHour} - {endHour}.",
    "PARTY_JACKPOT_WIN_POPUP_YOU_WON": "VOCÊ GANHOU O {jackpotName}",
    "PARTY_JACKPOT_WIN_POPUP_AWESOME": "INCRÍVEL!",
    "PARTY_JACKPOT_OUT_OF_CASH_TOASTER_TITLE": "Recarregue para jogar o Jackpot do Cassino Ao Vivo",
    "PARTY_JACKPOT_OUT_OF_CASH_TOASTER_SUBTITLE": "Você só ganha Jackpot do Cassino Ao Vivo com jogo por dinheiro",
    "JACKPOT-WIDGET-MUST-PAY": "Deve pagar em:",
    "JACKPOT-WIDGET-DROPS-SOON": "SERÁ GANHO EM BREVE!",
    "JACKPOT-WIDGET-STARTS-SOON": "COMEÇA EM BREVE",
    "JACKPOT-WIDGET-NEXT-JACKPOT": "Iniciando próximo Jackpot",
    "JACKPOT-WIDGET-LAST-WIN": "Últimos ganhos",
    "IN-GAME-WIDGET-STARTS-SOON": "Começa em breve",
    "FREEPLAY_INDICATOR": "Jogo Grátis",
    "OMG_INDICATOR": "Notificações",
    "USER_LIKE_YOU": "{topNumber} PRIMEIROS NO {countryName}",
    "YOUR_COUNTRY": "Seu país",
    "CLOSE": "Fechar",
    "LIVE_STREAM_WATCH_TIME_REACHED": "Pronto a entrar e jogar?",
    "LIVE_STREAM_VIDEO_LOADING": "A carregar...",
    "PLAY_NOW": "JOGAR AGORA",
    "CASINO": "CASSINO",
    "PAYMENTS_REDIRECT_FOCUS_TITLE": "Depósito em andamento",
    "PAYMENTS_REDIRECT_FOCUS_TEXT": "O seu ecrã de {mftName} ainda está aberto",
    "PAYMENTS_REDIRECT_FOCUS_CTA": "Continuar",
    "VOLATILE_SLOTS": "Slots voláteis",
    "VOLATILE_GAMES": "Jogos volátes",
    "HIGH_VOLATILITY_SLOTS": "Slots de alta volatilidade",
    "LOW_VOLATILITY_SLOTS": "Volatilidade baixa dos slots",
    "BURNOUT_MESSAGE_LINE_1": "SURPRISE!",
    "BURNOUT_MESSAGE_LINE_2": "YOU GOT A BONUS!",
    "CONGRATS": "Parabéns!",
    "YOUR_FP_ARE_WAITING": "O seu Jogo Grátis aguarda por si aqui",
    "EXIT_POPUP_TITLE": "É Possível Que Também Goste De",
    "DONT_SHOW_AGAIN_TEXT": "Não mostrar novamente",
    "GAMING_HISTORY_NO_RECORDS": "Não foi possível localizar nenhum registo de histórico dos seus jogos",
    "GAMING_HISTORY_LAST_PAGE": "Não há mais registos de histórico encontrados.",
    "GAMING_HISTORY_BET": "Apostar",
    "GAMING_HISTORY_WINNINGS": "Ganhos",
    "GAMING_HISTORY_WINNINGS_BONUS_CAP": "Ganhos*",
    "GAMING_HISTORY_BANKROLL": "Conta",
    "GAMING_HISTORY_MORE_DETAILS": "Mais pormenores",
    "GAMING_HISTORY_MORE_DETAILS_NOT_AVAILABLE_PC": "Disponível apenas em dispositivos móveis",
    "GAMING_HISTORY_MORE_DETAILS_NOT_AVAILABLE_MOBILE": "Disponível apenas em PC",
    "GAMING_HISTORY_FREE_PLAY_BET": "Apostar*",
    "GAMING_HISTORY_FREE_PLAY_WINNINGS": "Ganhos*",
    "GAMING_HISTORY_FREE_PLAY_REWARD_WINNINGS": "Ganhos de recompensa",
    "GAMING_HISTORY_FREE_PLAY_REWARD_BANKROLL": "Conta de recompensa",
    "GAMING_HISTORY_FREE_PLAY_INDICATION": "*Jogado com recompensas",
    "GAMING_HISTORY_FREE_PLAY_MAX_CUP_INDICATION": "*Ganho máximo",
    "GAMING_HISTORY_DAYS_INTERVAL": "Últimos {numberOfDays} Dias",
    "GAME_PARTICIPATION_ID": "ID de Participação: {participationID}",
    "GAME_SESSION_ID": "ID da Sessão: {sessionID}",
    "HISTORY_GAME_SESSION_TOTAL_BETS": "Total de apostas",
    "HISTORY_GAME_SESSION_TOTAL_WINNINGS": "Total de ganhos",
    "HISTORY_GAME_SESSION_BALANCE": "Saldo de Sessão",
    "GAME_WINDOW_VENDOR_SESSION_ID": "ID da Sessão: {sessionID}",
    "GAME_WINDOW_MODE_REAL_LABEL": "Dinheiro Real",
    "GAME_WINDOW_MODE_DEMO_LABEL": "Demo",
    "FREE_PLAY_VOUCHER_NAME_FPV": "FreePlay",
    "FREE_PLAY_VOUCHER_NAME_FSV": "Voltas Grátis",
    "FREE_PLAY_VOUCHER_NAME_JPFPV": "Jackpot FreePlay",
    "FREE_PLAY_VOUCHER_NAME_JPFSV": "Voltas de Jackpot",
    "FREE_PLAY_VOUCHER_BALANCE_PREFIX": "Restante:",
    "FREE_PLAY_VOUCHER_TITLE_FPV": "FreePlay Recompensa",
    "FREE_PLAY_VOUCHER_TITLE_FSV": "Recompensa de Voltas Grátis",
    "FREE_PLAY_VOUCHER_TITLE_JPFPV": "Recompensa FreePlay de Jackpot",
    "FREE_PLAY_VOUCHER_TITLE_JPFSV": "Recompensa de Voltas de Jackpot",
    "FREE_PLAY_VOUCHER_DESC_FPV": "Jogar dinheiro grátis para usar em jogos selecionados da maneira que desejar!",
    "FREE_PLAY_VOUCHER_DESC_FSV": "Voltas grátis com valores predefinidos para usar em jogos selecionados!",
    "FREE_PLAY_VOUCHER_DESC_JPFPV": "Dinheiro apenas com Jackpot FreePlay para usar em jogos selecionados da maneira que desejar!",
    "FREE_PLAY_VOUCHER_DESC_JPFSV": "Voltas Grátis apenas com Jackpot com valores predefinidos para usar em jogos selecionados!",
    "FREE_PLAY_VOUCHER_REWARD_AMOUNT": "{amount} {fp_voucher_name}",
    "FREE_PLAY_VOUCHER_REWARD_BALANCE": "{fp_voucher_remaining_prefix} {balance}",
    "FREE_PLAY_EXPIRES_IN_TIME": "Expira em {expiration}",
    "FREE_PLAY_EXPIRES_IN_EXPIRED": "Expirado",
    "FREE_PLAY_EXPIRES_IN_DAY": "Expira em {expiration} dias",
    "FREE_PLAY_MESSAGE_VOUCHER_TITLE_GOOD_LUCK": "Boa Sorte!",
    "FREE_PLAY_MESSAGE_LIST_TITLE": "Tem recompensas à sua espera. Boa Sorte!",
    "FREE_PLAY_MESSAGE_SELECTED_GAME_TITLE": "Este jogo também pode ser jogado com as seguintes recompensas:",
    "FREE_PLAY_MESSAGE_GAMES_LIST_TITLE": "Pode usar esta recompensa no(s) jogo(s) abaixo.",
    "FREE_PLAY_MESSAGE_NO_VOUCHERS": "Não tem recompensas disponíveis",
    "FREE_PLAY_MESSAGE_BACK_TO_VOUCHERS": "Voltar",
    "FREE_PLAY_SHOW_MORE": "Mostrar Mais",
    "FREE_PLAY_SHOW_LESS": "Mostrar Menos",
    "FREE_PLAY_USE_NOW_BUTTON": "Usar Agora",
    "FREE_PLAY_USE_LATER_BUTTON": "Usar Mais Tarde",
    "FREE_PLAY_SUGGESTION_DIALOG_TITLE": "Tem recompensas neste jogo!",
    "IDLE_RECOMMENDATIONS_TITLE": "Não consegue decidir o que jogar?",
    "IDLE_RECOMMENDATIONS_SECOND_TITLE": "Talvez você goste de: ",
    "BONUS_ABUSE_PREVENTION_TITLE": "Jogo desconectado",
    "BONUS_ABUSE_PREVENTION_MESSAGE": "Parece que um jogo foi desconectado....\n Conclua {gameName} para poder começar a jogar {newGameName}.",
    "BONUS_ABUSE_PREVENTION_NOT_NOW_BTN": "Agora não",
    "BONUS_ABUSE_PREVENTION_COMPLETE_BTN": "Concluir jogo",
    "OPEN_GAME_FROM_CHALLENGES": "Os desafios não podem ser concluídos usando recompensas.",
    "CANCEL": "Cancelar",
    "YES": "Sim",
    "NO": "Não",
    "ONE_GAME_PER_SESSION_DIALOG_TITLE": "Abrir jogo",
    "ONE_GAME_PER_SESSION_DIALOG_MESSAGE": "Parece que ainda há um jogo aberto...\n Deseja fechar {oldGameName} e começar a jogar {newGameName}?",
    "GAMES_OF_THE_WEEK": "Jogos da semana",
    "THE_FISH_MARKET": "O mercado de peixes",
    "LETS_PLAY_POKER": "Lets Play Poker!",
    "HYBRID_EMBEDDED_GAME_LOADING_SLOW_CONNECTION_TOASTER_TITLE": "Conexão lenta",
    "HYBRID_EMBEDDED_GAME_LOADING_SLOW_CONNECTION_TOASTER_SUBTITLE": "Detectamos uma conexão de rede lenta. Abrir o jogo pode demorar um pouco mais do que o esperado.",
    "HYBRID_EMBEDDED_GAME_LOADING_SPINNER_LABEL": "Conectando...",
    "HYBRID_EMBEDDED_GAME_LOADING_PACKAGES_PROGRESS": "Preparando jogo {packagesStatus}",
    "HELP_CENTER": "Centro De Ajuda",
    "ABOUT_TITLE": "Os Detalhes da Sua Conta",
    "ABOUT_SUPPORT_ID_TITLE": "ID para suporte",
    "ABOUT_FISCAL_CODE_TITLE": "Código Fiscal",
    "ABOUT_CLIENT_VERSION_TITLE": "Versão do Cliente",
    "ABOUT_HELP_SUPPORT": "Para qualquer consulta de suporte, visite a nossa ajuda online",
    "ABOUT_OPEN_SESSION_TITLE": "Saldo de sessão aberta",
    "ONE_HOUR": "1 hora",
    "X_HOURS": "{x} horas",
    "ONE_MINUTE": "1 minuto",
    "X_MINUTES": "{x} minutos",
    "ONE_DAY": "1 dia",
    "ONE_WEEK": "1 semana",
    "ONE_MONTH": "1 mês",
    "ADVANCED_MODE": "Modo Avançado",
    "SELECT": "Selecione",
    "DONT_WANT_TO_BE_BLOCKED": "Não desejo ser bloqueado",
    "START_PLAYING": "Começar a Jogar",
    "ES_GAME_LIMIT_RESTRICTION_PERIOD_VALUE": "Ser bloqueado por {time}",
    "ES_GAME_LOSS_LIMIT_VALUE": "{percent}% da conta ({loss})",
    "ES_TIME_LIMIT_DROP_DOWN_LABEL": "Duração máxima",
    "ES_LOSS_LIMIT_DROP_DOWN_LABEL": "Perda máxima",
    "ES_REMINDER_INTERVAL_DROP_DOWN_LABEL": "Intervalo do lembrete",
    "ES_RESTRICTION_PERIOD_DROP_DOWN_LABEL": "Quando a minha sessão termina, gostaria de:",
    "ES_GAME_TIME_LIMIT_REQUIRED_ERROR": "Selecione um limite de tempo",
    "ES_GAME_LOSS_LIMIT_REQUIRED_ERROR": "Selecione um limite de perda",
    "ES_GAME_LIMIT_REGULATORY_TEXT": "En 888casino.es apoyamos y promovemos {responsibleGamblingLink} y te ofrecemos las herramientas para controlar tanto el tiempo que juegas como el dinero que apuestas. Antes de empezar a jugar, configura tu sesión en función de tus preferencias",
    "ES_GAME_LIMIT_RESPONSIBLE_GAMING_LINK": "el juego responsable",
    "ES_GAME_LIMIT_TIME_LOSS_CONFIRMATION_TEXT": "Tenha em conta que definiu o seu tempo de jogo máximo em {time}.",
    "ES_GAME_LIMIT_TIME_LOSS_CONFIRMATION_QUESTION": "Pretende continuar?",
    "ES_GAME_LIMIT_RESTRICTION_BLOCK_CONFIRMATION_TEXT": "Optou por ser bloqueado para {time}. Isto significa que, uma vez a sua sessão de jogo terminada, não poderá jogar de novo pelo período de tempo que selecionou.",
    "ES_GAME_LIMIT_RESTRICTION_BLOCK_CONFIRMATION_QUESTION": "Tem a certeza?",
    "ES_GAME_LIMIT_TITLE": "Configure sua Sessão de Jogo",
    "ATTENTION": "Atenção!",
    "TOTAL_BANKROLL": "Conta Completa:",
    "GAME_SESSION_BALANCE": "Saldo de sessão:",
    "TOTAL_WINS": "Total de montantes de ganhos:",
    "TOTAL_BETS": "Total de montantes de apostas:",
    "ES_SESSION_TIME_LIMIT_MESSAGE": "Está prestes a atingir o seu tempo máximo. Pode terminar a sessão.",
    "ES_INTERVAL_REMINDER_MESSAGE": "Está a jogar há {timePassed}, o seu Total de Apostas é {totalBets} e Total de Ganhos é{totalWins}",
    "ES_SESSION_LOSS_LIMIT_MESSAGE": "Está prestes a atingir o seu orçamento máximo. Pode terminar a sessão.",
    "GAME_SESSION_SUMMARY_DIALOG_TITLE": "A sessão terminou",
    "GAME_SESSION_SUMMARY_DIALOG_MESSAGE": "A sua sessão para {game_name} terminou\n\nTotal de apostas: {total_bets_amount}\n\nTotal de ganhos: {total_wins_amount}",
    "OK": "OK",
    "INSUFFICIENT_FUNDS_TITLE": "Saldo insuficiente",
    "INSUFFICIENT_FUNDS_MESSAGE": "O seu saldo atual não é suficiente para este jogo. Para continuar a jogar, tem de começar por fazer um depósito no caixa.",
    "OPEN_CASHIER": "Abrir Caixa",
    "GAME_LIMIT_REAL_MONEY_WARNING_MESSAGE": "Só é possível jogar este jogo com seu saldo em dinheiro.",
    "SUGGEST_REAL_MODE_DIALOG_TITLE": "Jogo de Demonstração",
    "SUGGEST_REAL_MODE_DIALOG_TEXT": "Tenha em conta que o {game_name} será aberto no modo de demonstração.<br><br>Para jogar no modo com dinheiro real, registe-se ou inicie sessão em.",
    "PLAY_DEMO": "Jogar Demo",
    "UK_TSR_CONTINUE_OPT": "Continuar",
    "UK_TSR_REVIEW_REMINDERS_OPT": "Rever avisos",
    "UK_TSR_LOGOUT_OPT": "Terminar sessão",
    "UK_TSR_RESUME_GAME_OPT": "Resume Game",
    "UK_TSR_STOP_REMINDERS_OPT": "Stop all game time reminders",
    "UK_TSR_HISTORY_OPT": "Ver histórico",
    "UK_TSR_CLOSE_GAME_OPT": "Close Game",
    "TSR_CONFIRM": "OK",
    "TSR_SESSION_TIME_TEXT": "Tem a sessão ativa há:",
    "TSR_SUBTEXT": "O que quer fazer?",
    "TSR_TITLE": "Lembrete De Tempo Gasto",
    "TSR_MENU_LINK_LABEL": "Lembrete De Tempo Gasto",
    "GAME_NET_POSITION_LABEL": "Saldo do jogo",
    "GAME_DURATION_LABEL": "Duração do jogo",
    "GAME_LIMIT_TITLE": "Escolha o dinheiro no jogo",
    "REGULATORY_LIMIT_LABEL": "Limite regulamentar",
    "OTHER_LIMIT_LABEL": "Outro",
    "GAME_LIMIT_VALUE_ERROR": "Montante inválido. Tente novamente",
    "GAME_LIMIT_REGULATION_ERROR": "O montante máximo é de {regulationLimit}. Tente novamente.",
    "GAME_LIMIT_MIN_BET_ERROR": "Montante abaixo do mínimo da tabela. Tente novamente",
    "GEO_FREEZE_POPUP_TOP_TEXT": "Estamos a confirmar a sua localização.",
    "GEO_FREEZE_POPUP_MIDDLE_TEXT": "Este processo demora apenas alguns segundos. Esta janela fecha-se automaticamente após a confirmação.",
    "GEO_DIALOG_STANDARD_TITLE": "Location Verification",
    "AGE_ACKNOWLEDGE_POPUP_TITLE": "Confirmação",
    "AGE_ACKNOWLEDGE_POPUP_MESSAGE": "As pessoas com idade inferior a 21 anos não estão autorizadas a realizar jogos interativos. Confirme que tem uma idade superior a 21 anos",
    "AGE_ACKNOWLEDGE_POPUP_CONFIRM_BUTTON": "Confirmar",
    "AGE_ACKNOWLEDGE_POPUP_DECLINE_BUTTON": "Recusar",
    "Adventure": "Aventura",
    "Ancient Civilization": "Civilização Antiga",
    "Arabic": "Árabe",
    "Asian": "Asiático",
    "Classic Style": "Estilo Clássico",
    "Comics and Cartoons": "Quadrinhos e Desenhos Animados",
    "Diamonds and Gems": "Diamantes e Pedras Preciosas",
    "Egyptian": "Egípcio",
    "Fantasy and Folklore": "Fantasia e Folclore",
    "Farm and Pets": "Fazenda e Animais de Estimação",
    "Fish": "Peixes",
    "Fruit and Candy": "Frutas e Doces",
    "Greek Mythology": "Mitologia Grega",
    "Irish": "Irlandês",
    "Money and Leisure": "Dinheiro e Lazer",
    "Movies and Music": "Filmes e Músicas",
    "Seasonal": "Sazonal",
    "Space and Sci-fi": "Espaço e Ficção Científica",
    "Wildlife": "Animais Selvagens",
    "GAME_STUDIOS": "Estúdios de Jogos",
    "THEMES": "Temas",
    "GAME_FEATURES": "Recursos",
    "GAME_CATEGORIES": "Categorias",
    "FILTER_BY": "Filtrar",
    "NO_JACKPOT": "Sem Jackpot",
    "HIGH_STAKES": "Apostas Altas",
    "LOW_STAKES": "Apostas Baixas",
    "MULTIHAND": "Múltiplas mãos",
    "LIVE_BACCARAT": "Bacará ao vivo",
    "LIVE_POKER": "Poker ao vivo",
    "LIVE_GAME_SHOWS": "Game Shows ao vivo",
    "CRAPS": "Dados",
    "LIVE_ROULETTE": "Roleta ao Vivo",
    "MEDIUM_VOLATILITY": "Volatilidade média",
    "VOLATILITY": "Volatilidade",
    "SPEED_GAMES": "JOGOS RÁPIDOS",
    "generic_notification_popup_title": "Notificação",
    "MDP_INACTIVITY_DISCONNECTED_TEXT": "Foi desligado devido a inatividade.",
    "RICH_USER_NOT_LOGGED_IN": "Para ver seus desafios, inicie sessão",
    "temp_account_title": "Verificação de Conta",
    "temp_account_days_left": "Dias Restantes",
    "temp_account_upload_btn": "CARREGAR DOCUMENTOS AGORA",
    "MENU_ITEM_ABOUT": "Sobre",
    "MENU_ITEM_GAMING_SESSION_HISTORY": "Histórico de Sessões",
    "MENU_ITEM_GAMING_REMINDERS": "Lembrete de Tempo de Jogo",
    "MENU_ITEM_TOUCH_ID": "Login com dados biométricos",
    "MENU_ITEM_INACTIVITY_TIMEOUT_SETTINGS": "Definições",
    "MENU_ITEM_HYBRID_INFO": "Informações",
    "MENU_ITEM_CASHIER_VERIFY_ID": "Verificação da Identidade",
    "FEATURED_GAMES": "Jogos especiais",
    "LIVE_BACCARAT_BONANZA": "AO VIVO Baccarat Bonanza",
    "TOP_HOLLYWOOD_SLOTS": "TOP Slots de Hollywood",
    "THE_WILD_WEST": "O Oeste Selvagem",
    "TREASURES_OF_EGYPT": "Tesouros do Egito",
    "GRID_SLOTS": "Slots de grade",
    "SECRETS_OF_THE_GREEK_MYTHOLOGY": "Segredos da mitologia grega",
    "DIAMONDS_ARE_FOREVER": "Diamantes são eternos",
    "LUCK_OF_THE_IRISH": "Sorte do irlandês",
    "LIVE_CASINO_PAGE": "Página do Cassino AO VIVO",
    "NEW_LIVE_CASINO_GAMES": "Novos Jogos do Cassino AO VIVO",
    "TOP_LIVE_TABLE_GAMES": "TOP jogos de mesa ao vivo",
    "ARCADE_GAMES": "Jogos Arcade",
    "8_HOURS_JACKPOT": "8 horas de jackpot",
    "BIG_PLAYTECH_JACKPOTS": "Jackpots enormes da Playtech",
    "ONBOARDING_WELCOME_STEP_MAIN_TEXT": "Mais jogos. Jackpots maiores. Experiência personalizada.",
    "ONBOARDING_WELCOME_STEP_SECONDARY_TEXT": "Que tal conhecer sua nova página inicial?",
    "ONBOARDING_MENU_STEP_MAIN_TEXT": "Este menu mágico levará você à diversão",
    "ONBOARDING_MENU_STEP_SECONDARY_TEXT": "Jackpots, caça-níqueis, mesas AO VIVO e promoções",
    "ONBOARDING_USER_AREA_MAIN_TEXT": "Controle sua conta de um único lugar",
    "ONBOARDING_USER_AREA_SECONDARY_TEXT": "ID da conta, histórico de transações, informações de bônus e mais",
    "NEXT": "Próximo",
    "DONE": "Concluído",
    "kick_reason_general": "Foi desligado da sua conta",
    "kick_reason_20": "Foi desligado da sua conta porque iniciou sessão a partir de outro local",
    "kick_reason_21": "Detetámos que está a tentar iniciar sessão de fora do Estado de Nova Jérsia. Esta conduta viola a lei estadual de Nova Jérsia N.J.S.A 5:12-95.23a. Deve imediatamente cessar e desistir de tentar iniciar sessão de fora de Nova Jérsia. Mantivemos as suas informações de utilizador e tentativas futuras podem resultar numa ação de imposição.",
    "kick_reason_23": "Não podemos confirmar se está localizado no estado de Nova Jérsia, o que é uma exigência legal para apostas online. Verifique se o cartão Wi-Fi está ativado. Entre em contacto com o apoio ao cliente para que possamos ajudá-lo a resolver esse problema.",
    "kick_reason_24": "Detetámos que está a aceder à Internet por meio de um proxy, VPN ou outro serviço que tem a capacidade de deturpar a localização geográfica de um dispositivo. Embora o seu uso deste serviço possa ser inadvertido, não podemos confirmar a sua exigência legal de localização para apostas online. Entre em contacto com o apoio ao cliente para que possamos ajudá-lo a resolver esse problema.",
    "kick_reason_25": "Detetámos que está a tentar iniciar sessão de fora do Estado de Nova Jérsia. Esta conduta viola a lei estadual de Nova Jérsia N.J.S.A 5:12-95.23a. Deve imediatamente cessar e desistir de tentar iniciar sessão de fora de Nova Jérsia. Mantivemos as suas informações de utilizador e tentativas futuras podem resultar numa ação de imposição.",
    "kick_reason_26": "Não podemos confirmar se está localizado no estado de Nova Jérsia, o que é uma exigência legal para apostas online. Isto parece ser um problema técnico. Entre em contacto com o apoio ao cliente para que possamos ajudá-lo a resolver esse problema.",
    "kick_reason_27": "Para apostar, devemos verificar se está localizado em {stateName}. Descarregue {downloadPluginLink} e instale este plug-in que nos permitirá verificar a sua localização com base na sua ligação Wi-Fi.",
    "kick_reason_28": "Para apostar em dinheiro real, precisamos de atualizar o plug-in que nos permite verificar a sua localização. Clique em {installPlugin} para instalar.",
    "kick_reason_29": "Não podemos confirmar se está localizado no estado de Nova Jérsia, o que é uma exigência legal para apostas online. Isto parece ser um problema técnico. Entre em contacto com o apoio ao cliente para que possamos ajudá-lo a resolver esse problema.",
    "kick_reason_31": "Não podemos confirmar se está localizado no estado de Nova Jérsia, o que é uma exigência legal para apostas online. Isto parece ser um problema técnico. Entre em contacto com o apoio ao cliente para que possamos ajudá-lo a resolver esse problema.",
    "kick_reason_32": "Não podemos confirmar se está localizado no estado de Nova Jérsia, o que é uma exigência legal para apostas online. Isto parece ser um problema técnico. Entre em contacto com o apoio ao cliente para que possamos ajudá-lo a resolver esse problema.",
    "kick_reason_33": "Infelizmente, a rede a que está atualmente ligado não nos permite verificar se está em Nova Jérsia. Ligue-se a uma rede diferente e tente novamente.",
    "kick_reason_34": "Não podemos confirmar se está localizado no estado de Nova Jérsia, o que é uma exigência legal para apostas online. Isto parece ser um problema técnico. Entre em contacto com o apoio ao cliente para que possamos ajudá-lo a resolver esse problema.",
    "kick_reason_35": "De acordo com o regulamento estadual de Nova Jérsia, somos obrigados a determinar a sua localização exata. Ative os serviços de localização do seu dispositivo.",
    "kick_reason_36": "O seu dispositivo está a executar um software que pode ser utilizado para ignorar as verificações de geolocalização exigidas pela lei de Nova Jérsia. Embora o seu uso deste software possa ser inadvertido, não podemos confirmar a sua exigência legal de localização para apostas online. Entre em contacto com o apoio ao cliente para que possamos ajudá-lo a resolver esse problema.",
    "kick_reason_50": "O jogo que está a tentar abrir não está disponível de momento.",
    "kick_reason_51": "De acordo com os requisitos legais, é obrigado a realizar algumas ações na sua conta. Inicie sessão novamente para concluí-las.",
    "TOUCH_ID_SUB_CAPTION": "A funcionalidade será ativada na próxima vez que iniciar sessão.",
    "TOUCH_ID_CAPTION": "Pode iniciar sessão mais rapidamente com as funcionalidades Touch/Face ID no seu dispositivo.",
    "TERMS_AND_CONDITIONS": "Termos e Condições",
    "TOUCH_ID_INIT_SCREEN_ENABLE_BUTTON": "ATIVE AGORA",
    "TOUCH_ID_AUTO_SCREEN": "LOGIN (INICIAR SESSÃO) COM TOUCH/FACE ID",
    "TOUCH_ID_INFO": "<li>Ativar a funcionalidade Touch/Face ID neste dispositivo permitirá que qualquer pessoa cuja impressão digital seja guardada neste dispositivo para obter acesso total à sua conta 888. Não deve continuar a configurar esta funcionalidade se alguma impressão digital, além da sua própria, estiver armazenada neste dispositivo.</li><li>Ao usar Touch/Face ID para aceder à sua conta 888, concorda que é o único responsável por todas as transações na sua conta, independentemente de tais transações serem feitas por terceiros ou por qualquer pessoa com uma impressão digital guardada neste dispositivo.</li><li>Além disso, concorda que o operador da aplicação e seus afiliados (juntos, o \"Grupo 888\") não será responsabilizado por quaisquer consequências decorrentes do uso de Touch/Face ID para aceder à sua conta 888. O Grupo 888 não será responsável por qualquer perda, responsabilidade, dano, despesas ou custos incorridos através do uso desta funcionalidade.</li><li>Por cada aplicação 888 que tiver no seu dispositivo, apenas uma única das suas contas poderá ser configurada para iniciar sessão com Touch/Face ID a qualquer momento.</li><li>Terá de iniciar sessão usando a sua palavra-passe quando a autenticação por Touch/Face ID falha ou expira.</li><li>888 O Grupo não armazena a sua impressão digital nos seus servidores e não manipula ou suporta a tecnologia Touch/Face ID.</li>",
    "TABLE_GAMES": "Jogos de mesa",
    "ARCADE": "Arcade",
    "SPORTS": "Esportes",
    "SCRATCH_CARDS": "Raspadinhas",
    "MEXICAN": "Mexicano",
    "BINGO": "Bingo",
    "CLASSIC_STYLE_MODERNIZED": "Estilo clássico modernizado",
    "AZTEC_INCA_MAYAN": "Asteca Inca Maia",
    "CRIME": "Crime",
    "WILD_WEST": "Faroeste",
    "CANDY_AND_SWEETS": "Doces e doçuras",
    "GOLD_MINING": "Mineração de ouro",
    "VIKINGS_AND_NORDIC_MYTHOLOGY": "Vikings e mitologia nórdica",
    "XMAS": "Natal",
    "LAST_LOGIN_TITLE": "Último início de sessão:",
    "SESSION_TIMER_TITLE": "Tempo da sessão",
    "LIVE_SLOTS": "Slots ao vivo",
    "THE_BOOK_SHELF": "A Estante dos Livros",
    "LUCKYTAP_GAMES": "TOQUE DA SORTE",
    "TSR_WAGERED_AMOUNT": "Valor apostado",
    "TSR_SUBTITLE_MALTA": "Controle seu jogo!",
    "TSR_WINNINGS_TEXT": "Seu ganho total",
    "TSR_LOSSES_TEXT": "Total de perdas",
    "TSR_CLOSE_GAME": "Fechar o jogo"
  }
}